const SignupTrust = () => {
  const trustPoints = [
    {
      icon: 'ri-shield-keyhole-line',
      title: 'Your Data is Secure',
      desc: 'All information is encrypted and stored securely. We follow UK GDPR compliance standards to protect your personal and business details.',
    },
    {
      icon: 'ri-spam-2-line',
      title: 'Zero Spam, Guaranteed',
      desc: 'We only send relevant updates, offers, and insights from Everything Automation. No junk, no third-party promotions, ever.',
    },
    {
      icon: 'ri-logout-circle-line',
      title: 'Unsubscribe Anytime',
      desc: 'Every email includes a one-click unsubscribe. You can remove yourself from our list at any time, no questions asked.',
    },
    {
      icon: 'ri-user-settings-line',
      title: 'You Control Your Data',
      desc: 'Your information is used exclusively for account access, service communication, and updates from Everything Automation. Nothing else.',
    },
  ];

  return (
    <section className="bg-ea-black py-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-ea-blue/10 border border-ea-blue/30 mb-5">
            <span className="w-1.5 h-1.5 rounded-full bg-ea-blue"></span>
            <span className="text-ea-blue text-xs font-medium uppercase tracking-wider">Our Promise to You</span>
          </div>
          <h2 className="text-3xl font-bold text-white mb-4">Your Privacy Matters</h2>
          <p className="text-ea-gray text-base max-w-xl mx-auto">
            We built this platform on trust. Here's our commitment to every member.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mb-14">
          {trustPoints.map((t) => (
            <div
              key={t.title}
              className="bg-ea-dark-card border border-ea-dark-border rounded-xl p-4 sm:p-6 text-center group hover:border-ea-blue/30 transition-all duration-300"
            >
              <div className="w-9 h-9 sm:w-12 sm:h-12 flex items-center justify-center rounded-xl bg-ea-blue/10 border border-ea-blue/20 mx-auto mb-3 sm:mb-4">
                <i className={`${t.icon} text-ea-blue text-base sm:text-xl`}></i>
              </div>
              <h3 className="text-white font-semibold text-xs sm:text-sm mb-1.5 sm:mb-2 leading-snug">{t.title}</h3>
              <p className="text-ea-gray text-[11px] sm:text-xs leading-relaxed hidden sm:block">{t.desc}</p>
              <p className="text-ea-gray/80 text-[11px] leading-relaxed sm:hidden line-clamp-3">{t.desc}</p>
            </div>
          ))}
        </div>

        {/* Compliance strip */}
        <div className="border border-ea-dark-border rounded-xl p-6 bg-ea-dark-card flex flex-col sm:flex-row items-center justify-between gap-6">
          <div className="flex flex-wrap items-center justify-center sm:justify-start gap-6">
            {[
              { icon: 'ri-shield-check-line', label: 'UK GDPR Compliant' },
              { icon: 'ri-lock-2-line', label: 'SSL Encrypted' },
              { icon: 'ri-eye-off-line', label: 'No Data Selling' },
              { icon: 'ri-customer-service-2-line', label: 'Human Support' },
            ].map((item) => (
              <div key={item.label} className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className={`${item.icon} text-ea-blue`}></i>
                </div>
                <span className="text-ea-gray text-sm">{item.label}</span>
              </div>
            ))}
          </div>
          <p className="text-ea-gray/60 text-xs text-center sm:text-right max-w-xs shrink-0">
            All submissions are securely stored and used solely to improve communication and service updates.
          </p>
        </div>
      </div>
    </section>
  );
};

export default SignupTrust;
